"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

!function (o, e) {
  'object' == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && 'undefined' != typeof module ? module.exports = e() : 'function' == typeof define && define.amd ? define(e) : (o = o || self).uuidv4 = e();
}(void 0, function () {
  'use strict';

  var o = 'undefined' != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || 'undefined' != typeof msCrypto && 'function' == typeof window.msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto),
      e = new Uint8Array(16);

  function r() {
    if (!o) throw new Error('uuid: This browser does not seem to support crypto.getRandomValues(). If you need to support this browser, please provide a custom random number generator through options.rng.');
    return o(e);
  }

  for (var n = [], t = 0; t < 256; ++t) {
    n[t] = (t + 256).toString(16).substr(1);
  }

  return function (o, e, t) {
    var u = e && t || 0;
    'string' == typeof o && (e = 'binary' === o ? new Array(16) : null, o = null);
    var i = (o = o || {}).random || (o.rng || r)();
    if (i[6] = 15 & i[6] | 64, i[8] = 63 & i[8] | 128, e) for (var s = 0; s < 16; ++s) {
      e[u + s] = i[s];
    }
    return e || function (o, e) {
      var r = e || 0,
          t = n;
      return [t[o[r++]], t[o[r++]], t[o[r++]], t[o[r++]], '-', t[o[r++]], t[o[r++]], '-', t[o[r++]], t[o[r++]], '-', t[o[r++]], t[o[r++]], '-', t[o[r++]], t[o[r++]], t[o[r++]], t[o[r++]], t[o[r++]], t[o[r++]]].join('');
    }(i);
  };
});